import { connect } from "react-redux";

import { SeoRenderer } from "../../../../common/helpers/seo";
import { get, post } from "../../../actions/general";
import { IStateTree } from "../../../store/interfaces";
import { IUser } from "../../../store/user/models";

import loadable from "./loadable";

export default {
    component: connect(({ user }: IStateTree) => ({ user: user as IUser }), { get, post })(loadable),
    renderSeo: (_store, allMessage: any, lang: string) => {
        SeoRenderer({ title: "Musicators", allMessage, lang });
    },
};
